module.exports = __webpack_public_path__ + "media/images/riders/ELISABETH_BRANDAU-3e705d43ecd0134fad365e80fa45a106.png";